import React, { useEffect, useState } from 'react';
import { FiAlertCircle, FiEye, FiEyeOff, FiLock, FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useControlAuth } from '../../ControlAuthContext';
import './ControlLogin.css';

const ControlLogin = () => {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { user, login, authenticating, authError } = useControlAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate('/control', { replace: true }); }, [user, navigate]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    const result = await login(userid, password);
    if (!result.success) setError(result.error);
  };

  return (
    <main className="control-login-page"><section className="control-login-card">
      <div className="control-login-brand"><span>V</span><div><strong>Valley Control</strong><small>Operations workspace</small></div></div>
      <div className="control-login-copy"><span>Secure access</span><h1>Welcome back</h1><p>Sign in to manage orders, quotations and the control team.</p></div>
      <form className="control-login-form" onSubmit={handleSubmit}>
        <label htmlFor="control-userid">User ID</label>
        <div className="control-login-field"><FiUser /><input id="control-userid" type="text" value={userid} onChange={(event) => setUserid(event.target.value)} autoComplete="username" autoCapitalize="none" spellCheck="false" placeholder="Enter your user ID" maxLength="100" required autoFocus /></div>
        <label htmlFor="control-password">Password</label>
        <div className="control-login-field"><FiLock /><input id="control-password" type={showPassword ? 'text' : 'password'} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" placeholder="Enter your password" maxLength="128" required /><button type="button" onClick={() => setShowPassword((show) => !show)} aria-label={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? <FiEyeOff /> : <FiEye />}</button></div>
        {(error || authError) && <div className="control-login-error" role="alert"><FiAlertCircle /><span>{error || authError}</span></div>}
        <button className="control-login-submit" type="submit" disabled={authenticating || !userid.trim() || !password}>{authenticating ? <><span className="control-login-spinner" />Signing in…</> : 'Sign in'}</button>
      </form><p className="control-login-help">Access is limited to authorized Valley personnel.</p>
    </section></main>
  );
};

export default ControlLogin;
